<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      塘尾站<br>
站点介绍<br>
塘尾站位于塘尾村为本线的高架站之一，站址位于宝安大道与福永凤塘大道交叉口北侧，沿宝安大道路中南北向布置。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:18	23:49	11号线	4分钟	6分32秒<br>
碧头	06:33	00:17	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:18	23:49	11号线	4分34秒	6分钟<br>
碧头	06:33	00:17	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:18	23:49	11号线	4分37秒	6分钟<br>
碧头	06:33	00:17	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
富华工业区、宝安大道西侧<br><br>
B出入口:<br>
凤塘大道北侧、宝安大道西侧、华强城<br><br>
C出入口:<br>
宝安大道东侧、凤塘大道北侧、晓达宝隆分条厂<br><br>
D出入口:<br>
大朗山工业区、宝安大道东侧、<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坪山大道东纵路口（西侧）<br>
366、833、E20、M277、M295、M325、M326、M439、M546、高峰专线8、高峰专线64<br><br>
B出入口:<br>
公交站名： 坪山电子城①<br>
963、978、E22、E34、M136、M361、高峰专线8、深惠3A<br><br>
B出入口:<br>
公交站名： 坪山电子城②<br>
366、833、915、B760、E20、M326、M295、M434、M439、M443、M479、M575、M576、高峰专线64<br><br>
B出入口:<br>
公交站名： 坪山街道办<br>
B760、M575、M576<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>